// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__QtJKO","validationTips":"StatementDescriptor_validationTips__36TRi"};